export default __webpack_public_path__ + "static/media/lock-duotone-light.b8f5b810.svg";